import { log } from '../logging';
import { SEVERITY_TEXT } from '../constants';
import { tracer } from '../tracers';
import { getEnvKey } from 'constants/envs';
import { getIdsFromSpan, replaceIdWithPlaceholder } from '../utils';

/**
 * Creates an OpenTelemetry navigation span for the given page path.
 *
 * @param {string} pathname - The pathname of the navigated page (e.g., '/dashboard').
 * @param {import('@opentelemetry/api').Context} [parentContext] - (Optional) The OpenTelemetry parent context to link this navigation span.
 * @returns {import('@opentelemetry/api').Span} The created OpenTelemetry Span object.
 *
 * @example
 * const span = otNavigation('/settings', someParentContext);
 * // ...do something...
 * span.end();
 */
export function otNavigation(pathname, parentContext) {
    const path = `/#${pathname}`;
    const environment = getEnvKey();

    const span = tracer.startSpan(
        `Navigation: ${replaceIdWithPlaceholder(path)}`,
        {
            attributes: { path, environment },
        },
        parentContext,
    );

    log('Page Navigation', SEVERITY_TEXT.INFO, {
        event: 'navigation',
        path,
        environment,
        ...getIdsFromSpan(span),
    });

    return span;
}
